import {
    getAccessoryPartsRequest,
    getAirbagRequest,
    getBodyTypeRequest,
    getBrakesPartsRequest,
    getBrakesStateRequest,
    getCameraRequest,
    getCarbodyPartsRequest,
    getCityRequest,
    getClimateRequest,
    getCorporateRequest,
    getCruiseRequest,
    getDriveunitRequest,
    getElectricPartsRequest,
    getEnginePartsRequest,
    getEngineStateRequest,
    getEquipmentPartsRequest,
    getFuelRequest,
    getGasEquipmentPartsRequest,
    getHeatingPartsRequest,
    getInteriorPartsRequest,
    getInteriorRequest,
    getInteriorStateRequest,
    getMainStatsRequest,
    getMaintenancePartsRequest,
    getNamePartsRequest,
    getNamePlacementRequest,
    getNameServicesRequest,
    getOwnersRequest,
    getPowerSteeringRequest,
    getRegionRequest,
    getRegistrationRequest,
    getSeatsHeatRequest,
    getSeatsTypeRequest,
    getStatePartsRequest,
    getStateRequest,
    getSuspensionPartsRequest,
    getSuspensionStateRequest,
    getTransmissionPartsRequest,
    getTransmissionRequest,
    getTransmissionStateRequest,
    getTypePartsRequest,
    getTypePlacementRequest,
    getTypeServicesRequest,
    getTyreSeasonRequest,
    getVehicleColorRequest,
    getVehicleColorTypeRequest,
    getVehicleExchangeRequest,
    getWheelsBoltsRequest,
    getWheelsPartsRequest,
    getWheelsRadiusRequest,
    getWheelsWidthRequest,
    getYearsRequest,
    getAdvertsListCountRequest,
    moderateTextRequest,
    getVehicleReviewRequest,
    generateAiDescriptionRequest,
    getVehicleOptionsRequest,
    getFuelPricesRequest,
    translateTextRequest,
} from '../../../services/network/commonData';

class CommonVehicleDataService {
    async getAirbag() {
        return await getAirbagRequest();
    }

    async getBodyType() {
        return await getBodyTypeRequest();
    }

    async getCamera() {
        return await getCameraRequest();
    }

    async getClimate() {
        return await getClimateRequest();
    }

    async getVehicleExchange() {
        return await getVehicleExchangeRequest();
    }

    async getColorInterior() {
        return await getInteriorRequest();
    }

    async getCruise() {
        return await getCruiseRequest();
    }

    async getOwners() {
        return await getOwnersRequest();
    }

    async getPowerSteering() {
        return await getPowerSteeringRequest();
    }

    async getSeatsHeat() {
        return await getSeatsHeatRequest();
    }

    async getSeatsType() {
        return await getSeatsTypeRequest();
    }

    async getTransmission() {
        return await getTransmissionRequest();
    }

    async getRegistration() {
        return await getRegistrationRequest();
    }

    async getVehicleColor() {
        return await getVehicleColorRequest();
    }

    async getVehicleColorType() {
        return await getVehicleColorTypeRequest();
    }

    async getDriveunit() {
        return await getDriveunitRequest();
    }

    async getFuel() {
        return await getFuelRequest();
    }
}

export const VehicleDataService = new CommonVehicleDataService();

class CommonVehicleProDataService {
    async getEngineState() {
        return await getEngineStateRequest();
    }

    async getBrakesState() {
        return await getBrakesStateRequest();
    }

    async getInteriorState() {
        return await getInteriorStateRequest();
    }

    async getSuspensionState() {
        return await getSuspensionStateRequest();
    }

    async getTransmissionState() {
        return await getTransmissionStateRequest();
    }
}

export const VehicleProDataService = new CommonVehicleProDataService();

class CommonVehicleInfoService {
    async getTypeCorporate() {
        return await getCorporateRequest();
    }

    async getState() {
        return await getStateRequest();
    }

    async getYears() {
        return await getYearsRequest();
    }

    async getRegion() {
        return await getRegionRequest();
    }

    async getCity() {
        return await getCityRequest();
    }

    async getAdvertsListCount(payload) {
        return await getAdvertsListCountRequest(payload);
    }

    async moderateText(text) {
        return await moderateTextRequest(text);
    }

    async getVehicleReview(vehicleData, lang) {
        return await getVehicleReviewRequest(vehicleData, lang);
    }

    async generateAiDescription(vehicleData, lang) {
        return await generateAiDescriptionRequest(vehicleData, lang);
    }

    async getVehicleOptions(vehicleData, availableOptions) {
        return await getVehicleOptionsRequest(vehicleData, availableOptions);
    }

    async getFuelPrices() {
        return await getFuelPricesRequest();
    }

    async translateText(text, targetLang) {
        return await translateTextRequest(text, targetLang);
    }
}

export const VehicleInfoService = new CommonVehicleInfoService();

class CommonVehicleServicesService {
    async getNameServices() {
        return await getNameServicesRequest();
    }

    async getNamePlacement() {
        return await getNamePlacementRequest();
    }

    async getTypeServices() {
        return await getTypeServicesRequest();
    }

    async getTypePlacement() {
        return await getTypePlacementRequest();
    }
}

export const VehicleServicesService = new CommonVehicleServicesService();

// parts

class CommonVehiclePartsService {
    async getAccessoryParts() {
        return await getAccessoryPartsRequest();
    }

    async getBrakesParts() {
        return await getBrakesPartsRequest();
    }

    async getCarbodyParts() {
        return await getCarbodyPartsRequest();
    }

    async getElectricParts() {
        return await getElectricPartsRequest();
    }

    async getEngineParts() {
        return await getEnginePartsRequest();
    }

    async getEquipmentParts() {
        return await getEquipmentPartsRequest();
    }

    async getGasEquipmentParts() {
        return await getGasEquipmentPartsRequest();
    }

    async getHeatingParts() {
        return await getHeatingPartsRequest();
    }

    async getInteriorParts() {
        return await getInteriorPartsRequest();
    }

    async getMaintenanceParts() {
        return await getMaintenancePartsRequest();
    }

    async getNameParts() {
        return await getNamePartsRequest();
    }

    async getStateParts() {
        return await getStatePartsRequest();
    }

    async getSuspensionParts() {
        return await getSuspensionPartsRequest();
    }

    async getTransmissionParts() {
        return await getTransmissionPartsRequest();
    }

    async getTypeParts() {
        return await getTypePartsRequest();
    }

    async getTyreSeasonParts() {
        return await getTyreSeasonRequest();
    }

    async getWheelsParts() {
        return await getWheelsPartsRequest();
    }

    async getWheelsRadiusParts() {
        return await getWheelsRadiusRequest();
    }

    async getWheelsBoltsParts() {
        return await getWheelsBoltsRequest();
    }

    async getWheelsWidthParts() {
        return await getWheelsWidthRequest();
    }
}

export const VehiclePartsService = new CommonVehiclePartsService();

// Main Page
class CommonMainPageInfoService {
    async getMainStats() {
        return await getMainStatsRequest();
    }
}

export const MainPageInfoService = new CommonMainPageInfoService();
